<template>
    <div class="modal fade" id="channels_modal" tabindex="-1" aria-labelledby="" aria-hidden="true" ref="modalEl">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Manage Communication Channels</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">

                        <div v-if="channels" v-for="channel in nonconsentedChannels" :key="channel.id">
                            <div v-if="!channelEdits[channel.id]['editing']">
                                <div class="row mb-2">
                                    <div class="col-2 fw-bold">
                                        <span :class="channel.is_bad ? 'strikethrough' : ''">{{ channel.name }}</span>
                                    </div>
                                    <div class="col-7">
                                        <span v-if="channel.channel_type_id == 3" :class="channel.is_bad ? 'strikethrough' : ''"><!-- channel_type_id == 3 is 'Address' -->
                                            {{ JSON.parse(channel.address).street1 }}
                                            {{ JSON.parse(channel.address).street2 ? ', ' + JSON.parse(channel.address).street2 : '' }}
                                            {{ JSON.parse(channel.address).city ? ', ' + JSON.parse(channel.address).city : '' }}
                                            {{ JSON.parse(channel.address).zipcode ? ', ' + JSON.parse(channel.address).zipcode : '' }}
                                        </span>
                                        <span v-else :class="channel.is_bad ? 'strikethrough' : ''">{{ channel.address }}</span>
                                        <span v-if="channel.is_bad" class="badge bg-danger ms-2">bad</span>
                                        <span v-if="channel.is_primary" class="badge bg-secondary ms-2">primary</span>
                                    </div><!--.col-7 -->
                                    <div class="col-3 text-end">
                                        <button class="btn btn-primary btn-sm" title="Edit" @click="channelEdits[channel.id]['editing'] = true"><i class="bi-pencil"></i></button>
                                    </div>
                                </div><!--.row -->
                            </div><!-- v-if -->

                            <div v-else>
                                <div class="row mb-2">

                                    <div class="col-3">
                                        {{ channelEdits[channel.id]['channel_type'] }} label <input type="text" class="form-control" :value="channelEdits[channel.id]['name']" @input="e => channelEdits[channel.id]['name'] = e.target.value">
                                    </div>
                                    <div class="col-6">

                                        <div v-if="channel.channel_type_id == 3">
                                            <div class="row">
                                                <div class="col">
                                                    <div class="mb-2">
                                                        Address <input type="text" class="form-control" placeholder="Address" :value="channelEdits[channel.id]['street1']" @input="e => channelEdits[channel.id]['street1'] = e.target.value">
                                                    </div>
                                                    <div class="mb-2">
                                                        <input type="text" class="form-control" placeholder="Address 2" :value="channelEdits[channel.id]['street2']" @input="e => channelEdits[channel.id]['street2'] = e.target.value">
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-8">
                                                            <input type="text" class="form-control" placeholder="City" :value="channelEdits[channel.id]['city']" @input="e => channelEdits[channel.id]['city'] = e.target.value">
                                                        </div>
                                                        <div class="col-4">
                                                            <input type="text" class="form-control" placeholder="Zipcode" :value="channelEdits[channel.id]['zipcode']" @input="e => channelEdits[channel.id]['zipcode'] = e.target.value">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div><!-- v-if -->

                                        <div v-else>
                                            <div class="row">
                                                <div class="col">
                                                    {{ channelEdits[channel.id]['channel_type'] }}
                                                    {{ channelEdits[channel.id]['channel_type'] == 'Phone' ? 'number' : '' }}
                                                    {{ channelEdits[channel.id]['channel_type'] == 'Email' ? 'address' : '' }}
                                                    <input v-if="!attachedLogsExist(channel.id)" type="text" class="form-control" :value="channelEdits[channel.id]['address']" @input="e => {channelEdits[channel.id]['address'] = e.target.value; if (channelEdits[channel.id]['channel_type'] == 'Email') { validateEmail(e.target.value); }}">
                                                    <div v-else class="input-group">
                                                        <input type="text" class="form-control" :value="channelEdits[channel.id]['address']" @input="e => channelEdits[channel.id]['address'] = e.target.value" disabled="disabled">
                                                        <button class="btn btn-sm btn-warning input-group-text" v-tooltip="'Editing this field disabled. Channel has attached communication logs.'"><i class="bi bi-question-lg"></i></button>
                                                    </div>
                                                    <div v-if="emailError" class="text-danger">{{ emailError }}</div>
                                                </div>
                                            </div>
                                        </div><!-- v-else -->

                                        <div class="row mt-3">
                                            <div class="col-3">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" value="" id="is_primary_check" :checked="channelEdits[channel.id]['is_primary']" @click="channelEdits[channel.id]['is_primary'] = isChecked($event); channelEdits[channel.id]['is_bad'] = toggleChecked(channelEdits[channel.id]['is_primary'], channelEdits[channel.id]['is_bad']);">
                                                    <label class="form-check-label" for="is_primary_check">Primary</label>
                                                </div>
                                            </div>
                                            <div class="col-5">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" value="" id="is_bad_check" :checked="channelEdits[channel.id]['is_bad']" @click="channelEdits[channel.id]['is_bad'] = isChecked($event); channelEdits[channel.id]['is_primary'] = toggleChecked(channelEdits[channel.id]['is_bad'], channelEdits[channel.id]['is_primary']);">
                                                    <label class="form-check-label" for="is_bad_check">Bad channel</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-1">
                                            <div class="col">
                                                Notes <textarea class="form-control" id="notes" rows="2">{{ channelEdits[channel.id]['notes'] }}</textarea>
                                            </div>
                                        </div>

                                    </div><!--.col-6 -->
                                    <div class="col-3 d-flex justify-content-evenly align-items-center">
                                        <button v-if="channelEdits[channel.id]['name'] && (channelEdits[channel.id]['address'] || (channelEdits[channel.id]['street1'] && channelEdits[channel.id]['zipcode']))" class="btn btn-success btn-sm ms-3" title="Save" @click="saveChannel(channel.id)"><i class="bi-save"></i></button>
                                        <button v-else class="btn btn-success btn-sm ms-3 disabled" title="Save (disabled)"><i class="bi-save"></i></button>
                                        <button v-if="!attachedLogsExist(channel.id)" class="btn btn-danger btn-sm ms-2" title="Delete" @click="deleteChannel(channel.id)"><i class="bi-trash"></i></button>
                                        <button v-else class="btn btn-outline-danger btn-sm ms-2 fake-disabled" v-tooltip="'Disabled. Channel has attached communication logs.'"><i class="bi-trash"></i></button>
                                        <button class="btn btn-secondary btn-sm ms-2" title="Cancel" @click="channelEdits[channel.id]['editing'] = false"><i class="bi-x-lg"></i></button>
                                    </div>

                                </div><!--.row -->
                            </div><!-- v-else -->
                            
                            <hr>
                        </div><!-- v-if channels -->

                        <div v-if="newChannel['editing']">
                            <new-channel></new-channel>
                        </div>

                        <div v-if="!newChannel['editing']" class="row mt-3">
                            <div class="col"><button class="btn btn-primary btn-sm fw-bold" title="Add channel" @click="newChannel['editing'] = true"><i class="bi-plus-lg i-bold"></i></button></div>
                        </div>

                    </div><!--.container-fluid -->
                </div><!--.modal-body -->

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Done</button>
                </div>

            </div><!--.modal-content -->
        </div><!--.modal-dialog -->
    </div><!--.modal -->
</template>


<style scoped>
.i-bold {
    -webkit-text-stroke: 1px;
}
.strikethrough {
    text-decoration: line-through;
}
.fake-disabled {
    color: $red-400;
}
</style>


<script setup>
    import { onMounted, ref, computed } from "vue"
    import { storeToRefs } from 'pinia'
    import { Modal } from "bootstrap"
    import { useChannelsStore } from '../../stores/channels-store'
    import NewChannel from './partials/NewChannel.vue'
    const { channels, loading, error, channelEdits, newChannel, recipient } = storeToRefs(useChannelsStore())
    const { updateChannel, attachedLogsExist, deleteChannel } = useChannelsStore()

    // initialize modal
    let modalEl = ref(null)
    let channelsModalObj = null
    const emailError = ref('')

    onMounted(() => {
        channelsModalObj = new Modal(modalEl.value)
    })

    const nonconsentedChannels = computed(() => {
      return channels.value ? channels.value.filter(channel => channel.is_consented_type != 1) : [];
    })

    function toggleChecked(other, self) {
        // if other is checked, return false to uncheck self, else return self's current value
        return other ? false : self
    }

    function isChecked (e) {
        return e.target.checked ? 1 : null
    }

    function _show() {
        channelsModalObj.show()
    }
    function _hide() {
        channelsModalObj.hide()
    }
    defineExpose({ show: _show })

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(email)) {
            emailError.value = 'Invalid email address'
            return false
        }
        emailError.value = '' 
        return true
    }

    const saveChannel = (id) => {
        const channel = channelEdits.value[id];
        if (channel.channel_type === 'Email') {
            if (!validateEmail(channel.address)) {
                return 
            }
        }
        updateChannel(id)
    }    
</script>